export default __webpack_public_path__ + "static/messages-benefits-modal-986c36491126bbbde3e4dc51301e55aecac8ca8fa1258f56c93e0f78d5e74f47.jpg";